<template>
  <div class="banner">
    <div class="content">
      <div class="text">
        <span class="khoahoc khoahoc1">Khóa học</span><br />
        
        Tính toán lượng tử<br> <span class="khoahoc lythuyet">Lý thuyết và Thực hành</span>
      </div>
      <div class="time mt-3">14-22, Tháng 11, 2020</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.banner {
  background-image: url("../assets/banner.png");
  background-position: center;
  background-size: cover;
  height: 18rem;
  width: 100%;
  position: relative;
  @media (max-width: 500px) {
    height: 10rem;
  }
  @media (max-width: 460px) {
    height: 8rem;
  }

  .content {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate((0%, -50%));
    //text-align: center;
    //background: linear-gradient(to bottom left, #ccffcc56 0%, #ffffcc7c 100%);
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    @media (max-width: 768px) {
      width: 480px;
    }
    @media (max-width: 500px) {
      width: 100vw;
      border-radius: 0rem;
    }

    .text {
      font-size: 2.8rem;
      font-stretch: 5rem;
      font-family: "Roboto Slab", serif;
      font-weight: bold;
      background: radial-gradient(
        circle,
        rgb(92, 226, 14) 0%,
        rgba(168, 233, 148, 1) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      @media (max-width: 500px) {
        font-size: 1.8rem;
      }
      @media (max-width: 460px) {
        font-size: 1.5rem;
      }
      .khoahoc {
        font-size: 1.8rem;
        @media (max-width: 500px) {
           font-size: 1.3rem;
           display: inline-block;
           margin-top: 0.2rem;
        }
      }
      .khoahoc1{
        background: rgba(255, 255, 255, 0.404);
        padding: 5px 10px;
      }
      .lythuyet{
        display: block;
        margin-top: -0.6rem;
         @media (max-width: 500px) {
           font-size: 1.3rem;
        }
      }
    }
    .time {
      font-size: 1.5rem;
      font-weight: 300;
      font-family: 'EB Garamond', serif;
      background: radial-gradient(
        circle,
        rgb(92, 226, 14) 0%,
        rgba(168, 233, 148, 1) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      @media (max-width: 500px) {
        font-size: 1.2rem;
        margin-top: 0px!important;
      }
      @media (max-width: 460px) {
        font-size: 1rem;
      }
    }
  }
}
</style>